<div class="sale-voucher form__container">
  <div class="form__header">
    <div class="form__label-title">
      @if (isVoucherReturn) {
        <span>{{ "webPos.Voucher.VoucherRefundTitle" | translate: { id: voucherReturnDocId } }}</span>
      } @else {
        <span>{{ "webPos.Voucher.Voucher" | translate }}</span>
        @if (voucherCode) {
        <span>&nbsp;{{ voucherCode }}</span>
        }
      }
    </div>
  </div>

  <div class="form__content">
    <div class="sale-voucher__content-side">

      <form [formGroup]="voucherForm" class="form__content-side">
        <div class="form__content-form-input-row">

          <app-dropdown label="webPos.Voucher.VoucherType" formControlName="voucherType"
            class="form__content-form-input" [options]="voucherTypeOptions"
            (selectionChange)="onVoucherTypeChange($event)">
          </app-dropdown>

          <app-dropdown label="webPos.Voucher.VoucherSkin" formControlName="voucherVisual"
            class="form__content-form-input" [options]="voucherStyleOptions"
            (selectionChange)="onVoucherStyleChange($event)">
          </app-dropdown>
          
        </div>
        <div class="form__content-form-input-row">
          <app-form-input class="form__content-form-input" label="webPos.Name" [type]="FormInputType.Text"
            formControlName="ownerName">
          </app-form-input>
          <app-form-input class="form__content-form-input" label="webPos.Surname" [type]="FormInputType.Text"
            formControlName="ownerSurname">
          </app-form-input>
        </div>

        <div class="form__content-form-input-row">
          <app-form-input class="form__content-form-input" label="webPos.Street" [type]="FormInputType.Text"
            formControlName="ownerAddress">
          </app-form-input>
          <app-dropdown label="webPos.State" formControlName="ownerState"
            class="form__content-form-input" [options]="stateOptions">
          </app-dropdown>
        </div>

        <div class="form__content-form-input-row">
          <app-form-input class="form__content-form-input" label="webPos.City" [type]="FormInputType.Text"
            formControlName="ownerCity">
          </app-form-input>
          <app-form-input class="form__content-form-input" label="webPos.ZIP" [type]="FormInputType.Text"
            formControlName="ownerZipCode">
          </app-form-input>
        </div>

        <div class="form__content-form-input-row">
          <app-form-input class="form__content-form-input" label="webPos.Email" [type]="FormInputType.Email"
            formControlName="ownerEmail">
          </app-form-input>
          <label class="form__checkbox">
            <input type="checkbox" id="send" formControlName="sendEmailToOwner" />
            <span>{{ 'webPos.Voucher.sendVoucherToEmail' | translate }}</span>
          </label>
        </div>

        <div class="form__content-form-input-row">
          <app-form-input class="form__content-form-input" label="webPos.CIN" [type]="FormInputType.Text"
            formControlName="ownerCIN">
          </app-form-input>
          <app-form-input class="form__content-form-input" label="webPos.TIN" [type]="FormInputType.Text"
            formControlName="ownerTIN">
          </app-form-input>
        </div>

        <div class="form__content-form-input-row">
          <app-form-input class="form__content-form-input" label="webPos.Phone" [type]="FormInputType.Text"
            hint="webPos.PhoneFormatHint" [formatPhoneNumberOnBlur]="true" formControlName="ownerPhone">
          </app-form-input>
          <div class="form__content-form-input">
          </div>
        </div>
        <div class="form__content-form-input-row">
          <app-form-input class="form__content-form-input" label="webPos.Voucher.VoucherText"
            [type]="FormInputType.Text" [maxLength]="200" formControlName="note">
          </app-form-input>
        </div>
      </form>

    </div>
    <div class="form__content-side">
      @if (!isVoucherReturn && (payments | async).length > 0) {
      <div class="form__content-side-price-container">
        <app-payments [payments]="payments | async" (paymentReturned)="reloadExistingTransaction()" (paymentsRefreshRequested)="reloadExistingTransaction()" [formEmail]="voucherForm?.get('ownerEmail')?.value"></app-payments>
      </div>
      }
      <!-- Voucher Return (CR) -->
      <div class="sale-voucher__voucher-return"
           *ngIf="isVoucherReturn && !(voucherProcessing | async) && !processingFailed() && !voucherReturnCompleted()">
        <app-voucher-return-amounts
          [maxGift]="voucherReturnMaxGift"
          [maxBenefit]="voucherReturnMaxBenefit"
          [showGift]="voucherReturnSource !== 'eTravel'">
        </app-voucher-return-amounts>
      </div>

      @if (!selectedVoucherStyle?.imgUrl) {
      <div>{{ 'webPos.Voucher.SelectVisual' | translate }} </div>
      }
      @else {
      <img [ngSrc]="selectedVoucherStyle.imgUrl" width="1122" height="793" class="sale-voucher__image" priority alt="" />
      }
      <div class="payments-methods" *ngIf="isVoucherReturn && voucherReturnCompleted()">
        <div class="sale-voucher__payment-button">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'print']" (clicked)="printRefundVoucher()">
            {{ 'webPos.Voucher.PrintVoucher' | translate }}
          </app-card-button>
        </div>
        <div class="sale-voucher__payment-button">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'receipt']" (clicked)="printRefundReceipt()">
            {{ 'webPos.Voucher.PrintReceipt' | translate }}
          </app-card-button>
        </div>
        <div class="sale-voucher__payment-button">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'arrow-left']" (clicked)="navigateBackToSource()">
            {{ backToSourceLabelKey() | translate }}
          </app-card-button>
        </div>
      </div>

      <div class="payments-methods"
           *ngIf="isVoucherReturn && !(voucherProcessing | async) && !processingFailed() && !voucherReturnCompleted()
                  && (voucherReturnMaxGift > 0 || voucherReturnMaxBenefit > 0) && voucherForm.valid">
        <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
          [buttonIcon]="['fas', 'check']" (clicked)="confirmVoucherReturn()">
          {{ "webPos.Voucher.CreateVoucher" | translate }}
        </app-card-button>
      </div>
      <div class="payments-methods" *ngIf="!isVoucherReturn && !(voucherProcessing | async) && !processingFailed() && !!voucherForm">

        <div class="sale-voucher__payment-button" *ngIf="canUsePayment('cash')">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'money-bill-wave']" [disabled]="voucherForm.invalid" (clicked)="payByCash()">
            {{ "webPos.Cash" | translate}}
          </app-card-button>
        </div>

        <div class="sale-voucher__payment-button" *ngIf="canUsePayment('card')">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'credit-card']" [disabled]="voucherForm.invalid"
            [warning]="!isCardPaymentEnabled()"
            (clicked)="payByCard()">
            {{ 'webPos.Card' | translate }}
          </app-card-button>
        </div>


        <div class="sale-voucher__payment-button" *ngIf="canUsePayment('benefits')">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'money-check-dollar']" [disabled]="voucherForm.invalid"
            (clicked)="showBenefitPaymentForm()">
            {{ 'webPos.Benefits' | translate }}
          </app-card-button>
        </div>

        <div class="sale-voucher__payment-button sale-voucher__print-button" *ngIf="paymentHeaderForPrint">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'print']" [disabled]="!paymentHeaderForPrint" (clicked)="printVoucherDocument()">
            {{ 'webPos.Print' | translate }}
          </app-card-button>
        </div>

        <div class="sale-voucher__payment-button" *ngIf="paymentHeaderForPrint && !isVoucherReturn">
          <app-card-button [buttonSize]="CardButtonSize.Small" [buttonBackground]="CardButtonBackground.Tertiary"
            [buttonIcon]="['fas', 'plus']" (clicked)="startNextVoucherSale()">
            {{ 'webPos.Voucher.NextVoucher' | translate }}
          </app-card-button>
        </div>
      </div>

    </div>
  </div>
</div>
